/**
 * 从 widget 点击打开的产品登录页弹框
 * 登录之后需自动关闭弹框
 */

const localStorageKey = 'loginFromWidget';

/**
 * 存储登录标识至 sessionStorage
 * 由于google登录会存在重定向问题，需将登录标识存储至sessionStorage，如果是widget中登录的，则需要自动关闭弹框
 */
export function setLoginFromWidgetFlag(): void {
    sessionStorage.setItem(localStorageKey, 'true');
}

export function isLoginFromWidget(): boolean {
    return (
        location.href.indexOf('login?from=widget') !== -1 ||
        (!!sessionStorage.getItem(localStorageKey) && !!window.opener)
    );
}

export function clearLoginFromWidgetFlag(): void {
    sessionStorage.removeItem(localStorageKey);
}

export function hideWidget(): void {
    document.body.classList.add('hide-widget');
}
